module.exports = __webpack_public_path__ + "gb-nir.svg?5329af5915b425ea338f2eef0bac7af6";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/gb-nir.svg
// module id = 1715
// module chunks = 0